import { h } from "preact";
import { sortObjectByOrder } from "utils/utils.js";
import { Link } from "components/core/link/link.js";
import Page  from 'components/pages/page.js';
import HTML from "components/core/html/html.js";
import s from "components/pages/homeEnt/homeEnt.sss";
import * as BaseComp from 'components/pages/homeEnt/homeEnt.js';

export default class HomeEnt extends BaseComp.default {

	//LIFECYCLE JAZZ
	//-----------------------------------------
	// constructor(...args){
	// 	super(...args);

	// 	//scope binding
	// 	this.renderFormat = this.renderFormat.bind(this);
	// }//constructor

	// renderVendor(props, state, data, index){

	// 	const {
	// 		name           = "", // (string) name of the vendor (cased correctly)
	// 		trackingPrefix = "",
	// 		logo           = "", // (string) path to the logo of the vendor
	// 		url            = "",  // (string) destination to go to when the vendor is clicked
	// 		caption        = ""
	// 	} = data;

	// 	//tracking label to fire when the vendor is clicked
	// 	//const trackId = `homeEnt-${name.toLowerCase().replace(/ /g,"-")}-button-click`;
	// 	const trackId = `${trackingPrefix} ${name}`;
	// 	return(
	// 		<li class={s.vendor}>
	// 			<Link
	// 				class={s.link}
	// 				href={url}
	// 				trackId={trackId}
	// 				target="_blank"
	// 				style={`background-image: url(${logo})`}
	// 				renderCustomChild>
	// 				<span class={s.label}>
	// 					{name}
	// 				</span>
	// 			</Link>
	// 			<div class={s.caption}>{caption}</div>
	// 		</li>
	// 	);
	// }//renderVendor
	// renderFormat(props, state, data){

	// 	const {
	// 		title = "", // (string) which format the following vendors are selling
	// 		list  = {}  // (object) containing a data object for each vendor to render out
	// 	} = data;

	// 	//sort and render out the vendor-list
	// 	const vendors = sortObjectByOrder(list).map(this.renderVendor.bind(true, props, state));

	// 	return(
	// 		<section class={s.vendors}>
	// 			<HTML
	// 				class={s.title}
	// 				tag="h1">
	// 				{title}
	// 			</HTML>
	// 			<ul class={s.list}>
	// 				{vendors}
	// 			</ul>
	// 		</section>
	// 	);
	// }//renderFormat
	// render(props, state){

	// 	const {
	// 		pageData = {}, // (object) containing the page's data item from thundr
	// 		appData  = {}  // (object) overall data object for the app
	// 	} = props;

	// 	const {
	// 		vendors: vendorData = {}, // (object) containing data objects for physical and digital vendors
	// 	} = pageData;

	// 	const imageRegionRoot  = appData.urls.roots.imageRegion;

	// 	//sort and render out the vendors
	// 	const vendors         = sortObjectByOrder(vendorData).map(this.renderFormat.bind(true, props, state))

	// 	return(
	// 		<main class={s.wrapper}>
	// 			<div class={s.container}>
	// 				<header class={s.header}>
	// 					<h1 class={s.tt}>
	// 						<img
	// 							class={s.image}
	// 							src={`${imageRegionRoot}/tt-homeent.png`}
	// 							alt="Title-treatment for Slay the Dragon"
	// 						/>
	// 						<span class={s.text}>
	// 							Slay the Dragon
	// 						</span>
	// 					</h1>
	// 				</header>
	// 				{vendors}
	// 			</div>
	// 		</main>
	// 	);
	// }//render

}
